import { TIMEZONES } from '@/mocks/marketCalendar';

export default function TimeZoneSelector({
  value,
  onChange,
}: {
  value: string;
  onChange: (id: string) => void;
}) {
  return (
    <div className="flex items-center gap-3">
      <span className="hidden items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-slate-500 sm:flex">
        <i className="ri-time-zone-line text-base text-slate-400" />
        Múi giờ
      </span>
      <div className="flex flex-wrap gap-1 rounded-xl bg-slate-100 p-1">
        {TIMEZONES.map((tz) => {
          const active = tz.id === value;
          return (
            <button
              key={tz.id}
              type="button"
              onClick={() => onChange(tz.id)}
              className={`whitespace-nowrap rounded-lg px-3 py-1.5 text-xs font-semibold transition-all ${
                active ? 'bg-white text-violet-700 shadow-sm' : 'text-slate-500 hover:text-slate-700'
              }`}
            >
              {tz.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}